import { useMemo } from 'react'
import { useLocation } from '@reach/router'
import qs from 'qs'

export default (init = {}) => {
  const location = useLocation()

  return useMemo(() => {
    const params = qs.parse(location.search, {
      ignoreQueryPrefix: true
    })
    return { ...init, ...params }
  }, [location.search, init])
}
